<template>
  <div id="app">
    <h2>用户注册</h2>
    <div id="form">
      <i-form ref="formInline" :model="formInline" :rules="ruleInline" inline>
        <i-formItem prop="user">
          <i-input type="text" v-model="formInline.user" placeholder="姓名" clearable style="width:600px">
            <span class="iconfont" slot="prepend">&#xe629;</span>
          </i-input>
        </i-formItem>
        <br />
        <i-formItem prop="nickName">
          <i-input type="text" v-model="formInline.nickName" placeholder="昵称" clearable style="width:600px">
            <span class="iconfont" slot="prepend">&#xe6a0;</span>
          </i-input>
        </i-formItem>
        <br />
        <i-formItem prop="phoneNum">
          <i-input type="tel" v-model="formInline.phoneNum" placeholder="请输入手机号" clearable style="width:600px">
            <span class="iconfont" slot="prepend">&#xe612;</span>
          </i-input>
        </i-formItem>
        <br />
        <i-formItem prop="password" v-if="flag">
          <i-input type="password" password v-model="formInline.password" placeholder="密码" style="width:600px">
            <!-- <span class="iconfont" slot="prepend">&#xe640;</span> -->
            <i-icon @click="handlePassword" type="ios-eye-off-outline" size="20" slot="prepend"></i-icon>
          </i-input>
        </i-formItem>
        <i-formItem prop="password" v-else>
          <i-input type="text" v-model="formInline.password" placeholder="密码" style="width:600px">
            <!-- <span class="iconfont" slot="prepend">&#xe640;</span> -->
            <i-icon @click="handlePassword" type="ios-eye-outline" size="20" slot="prepend"></i-icon>
          </i-input>
        </i-formItem>
        <br />
        <i-formItem prop="passwordCheck" v-if="flag1">
          <i-input type="password" v-model="formInline.passwordCheck" placeholder="密码确认" style="width:600px">
            <!-- <span class="iconfont" slot="prepend">&#xe640;</span> -->
            <i-icon @click="handlePassword1" type="ios-eye-off-outline" size="20" slot="prepend"></i-icon>
          </i-input>
        </i-formItem>
        <i-formItem prop="passwordCheck" v-else>
          <i-input type="text" v-model="formInline.passwordCheck" placeholder="密码确认" style="width:600px">
            <!-- <span class="iconfont" slot="prepend">&#xe640;</span> -->
            <i-icon @click="handlePassword1" type="ios-eye-outline" size="20" slot="prepend"></i-icon>
          </i-input>
        </i-formItem>
        <br />
        <i-formItem>
          <i-button type="primary" @click="handleSubmit()" style="width:600px">注册</i-button>
        </i-formItem>
        <br />
      </i-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    // 密码验证
    const pwdCheck = async (rule, value, callback) => {
      if (value.length < 1) {
        return callback(new Error("密码不能为空"))
      } else {
        callback()
      }
    }
    // 重复密码验证
    const pwdAgainCheck = async (rule, value, callback) => {
      if (value.length < 1) {
        return callback(new Error("重复密码不能为空！"))
      } else if (this.formInline.password !== this.formInline.passwordCheck) {
        return callback(new Error("两次输入密码不一致！"))
      } else {
        callback()
      }
    }
    return {
      formInline: {
        user: "",
        password: "",
        passwordCheck: "",
        nickName: "",
        phoneNum: "",
      },
      flag: true,
      flag1: true,
      ruleInline: {
        user: [{ required: true, message: "请填写用户名", trigger: "blur" }],
        nickName: [{ required: true, message: "请填写昵称", trigger: "blur" }],
        phoneNum: [
          { required: true, message: "请填写手机号", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur" },
        ],
        password: [{ required: true, validator: pwdCheck, trigger: "blur" }],
        passwordCheck: [{ required: true, validator: pwdAgainCheck, trigger: "blur" }],
      },
    }
  },
  methods: {
    //判断是否提交成功
    async handleSubmit() {
      const self = this
      const Register = {
        name: self.formInline.user,
        nickname: self.formInline.nickName,
        mobile: self.formInline.phoneNum,
        password: self.formInline.password,
      }
      const res = await self.axios({
        method: "get",
        url: self.$store.state.baseurl + "api/user/register",
        params: Register,
      })
      if (!res) {
        return
      }
      if (res.data.code === 0) {
        self.$Message.info("注册成功，等待管理员审核")
      } else if (res.data.code === -1) {
        self.$Message.info("手机号已被注册过")
      } else {
        self.$Message.error(res.data.error_message)
      }
    },
    handlePassword() {
      this.flag = !this.flag
    },
    handlePassword1() {
      this.flag1 = !this.flag1
    },
  },
}
</script>
<style scoped>
#app {
  position: relative;
  margin: 0 auto;
}
#app h2 {
  text-align: center;
  color: #202891;
  font-size: 43px;
  padding: 100px 0 0;
  position: relative;
}
#form {
  text-align: center;
  margin: 20px 0 0;
  position: relative;
}
</style>
